module.exports = __webpack_public_path__ + "img/true.48bd41a3.svg";